import React, {Fragment} from 'react';
import Notification from './Notification';
import {useInfiniteQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {
    fetchUserNotifications, markUserAllNotificationOpen,
    markUserNotificationOpen, USER_CURRENT_KEY,
    USER_NOTIFICATIONS_KEY, USER_UNREAD_NOTIFICATIONS_KEY
} from "../../../api/public-voissa/users";
import './NotificationList.scss';
import _ from "lodash";
import Button from '../UI/Button/Button';
import Group from "../UI/Group/Group";
import createLink from "../../../libs/createLink";


const NotificationsList = ({
        isPage = false,
        ...props
    }) =>{

    let filter = {
        limit: 20,
        lastId: null
    };

    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);

    const {
        mutate : mutateOpenAllNotification,
        isLoading : isLoadingOpenAllNotification
    } = useMutation(() => markUserAllNotificationOpen(),{
        onSuccess: async () =>{
            //await queryClient.invalidateQueries([USER_UNREAD_NOTIFICATIONS_KEY]);
            await queryClient.invalidateQueries([USER_NOTIFICATIONS_KEY]);
        }
    });

    const {isSuccess : isSuccessNotifications, isFetchingNextPage : isFetchedNotifications, data : dataNotifications, fetchNextPage : fetchNextPageNotifications, hasNextPage : hasNextPageNotifications} = useInfiniteQuery(
        [USER_NOTIFICATIONS_KEY],
        ({pageParam = null}) => fetchUserNotifications({...filter, lastId : pageParam}),
        {
            staleTime : false,
            onSuccess : async () =>{
                await queryClient.invalidateQueries([USER_UNREAD_NOTIFICATIONS_KEY]);
            },
            getNextPageParam: (lastPage, pages) => lastPage && lastPage.more ? lastPage.lastId : null
        }
    );

    const {
        mutate : mutateReadNotification,
    } = useMutation(notificationId => markUserNotificationOpen(notificationId),{
        onSuccess: (data) =>{

            const queryCache = queryClient.getQueryCache()
            const queryKeys = queryCache.getAll().map(cache => cache.queryKey).filter(cache => cache[0] === USER_NOTIFICATIONS_KEY);

            queryKeys.forEach(queryKey =>{
                const previousValue = queryClient.getQueryData(queryKey);
                if(previousValue){
                    const newPagesArray = previousValue?.pages.map((page) => {
                            page.data = page.data.map((item) => {
                                if(item._id.toString() === data._id.toString()){
                                    item = {...item, open : true};
                                }
                                return item;
                            });
                            return page;
                        }
                    ) ?? []

                    queryClient.setQueryData(queryKey, oldData => ({
                        pages: newPagesArray,
                        pageParams: oldData.pageParams,
                    }));
                }
            });

        }
    });



    let totalNotification = _.get(dataNotifications,'pages[0].total') || 0;

    return (
        <div className="notifications-list" {...props}>
            <Group split style={{marginBottom : "10px"}}>
                <Button onClick={() => mutateOpenAllNotification()} loading={isLoadingOpenAllNotification}>Tout marquer comme lu</Button>
                <Button isLink to={createLink("userMeSettingsOptionsNotifications", currentUser)}>Paramètres</Button>
            </Group>
            {isFetchedNotifications && "Chargement des notifications"}
            {totalNotification === 0 ? (
                    <div className="no-content">Aucune notification pour le moment</div>
                ) :
                isSuccessNotifications && dataNotifications.pages.map((group, i) => (
                    <Fragment key={i}>
                        {group.data.map((notification, index) => (
                            <Notification
                                key={index}
                                data={notification}
                                onOpen={() => {
                                    if (!notification.open) mutateReadNotification(notification._id);
                                }}/>
                        ))}
                    </Fragment>
                ))
            }
            {(isPage && hasNextPageNotifications) && <div className="see-more-notifications">
                <Button loading={isFetchedNotifications} onClick={() => fetchNextPageNotifications()}>Afficher plus de notifications</Button>
            </div>}
        </div>
    )
};

export default NotificationsList;